/** Textes « plus » — le français fait foi. */
export const plus = {
  titre: 'Menu',
  seDeconnecter: 'Se déconnecter',
};
